'use client';

// usePrefersReducedMotion — the OS-level "reduce motion" preference as a
// reactive boolean. A named-query wrapper over `useMediaQuery` (BL-1511): the
// query carries meaning ("the user opted out of motion") that a bare string
// does not, and three bidder-web surfaces (auth crossfade, auth switch link,
// input shake) read exactly this preference. Appearance-free behavior, so it
// lives in the shared foundation beside `useMediaQuery` (ADR 030 Decision 2).

import { useMediaQuery } from './useMediaQuery';

/** The media query for the OS reduced-motion preference. */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the user has asked the OS to reduce motion.
 *
 * Inherits `useMediaQuery`'s hydration contract: SSR and the first client
 * paint read `false` (motion on), then the real preference lands after
 * hydration. Consumers that gate a transition on this therefore never skip
 * a transition the server already committed to.
 *
 * @returns `true` when `(prefers-reduced-motion: reduce)` matches, else `false`.
 */
export function usePrefersReducedMotion(): boolean {
    return useMediaQuery(REDUCED_MOTION_QUERY);
}
